document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.product-form--modern').forEach((form) => {
    const select = form.querySelector('select[name="id"]');
    const buybox = form.closest('.product-buybox');
    if (!select || !buybox) return;

    const price = buybox.querySelector('[data-product-price]');
    const comparePrice = buybox.querySelector('[data-product-compare-price]');
    const submit = form.querySelector('[data-product-submit]');

    const updateVariant = () => {
      const option = select.selectedOptions[0];
      if (!option) return;

      if (price) price.textContent = option.dataset.price || '';

      const comparison = option.dataset.comparePrice || '';
      if (comparePrice) {
        comparePrice.textContent = comparison;
        comparePrice.hidden = !comparison;
      }

      const available = option.dataset.available === 'true';
      if (submit) {
        submit.disabled = !available;
        submit.textContent = available ? 'Add to cart' : 'Sold out';
      }

      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      window.history.replaceState({}, '', url);
    };

    select.addEventListener('change', updateVariant);
    updateVariant();
  });
});
